// Organization-specific constants & feature gating helpers.
// Used to enable bespoke functionality for specific tenants without
// affecting the rest of the platform.

export const RB_RESTORATION_ORG_ID = "abd9e111-06ca-48d3-bbed-a2c595cd28c1";

export const isRBRestoration = (orgId: string | null | undefined): boolean =>
  orgId === RB_RESTORATION_ORG_ID;
